<template>
    <div class="addText">
        <h4 style="line-height: 40px;text-align: center">{{title}}</h4>
        <textarea class="textarea" v-model="content" :placeholder="placeholder"/>

        <div v-if="type === 'subtitle'">
            <van-collapse v-model="activeNames" accordion @change="setactiveNames">
                <van-collapse-item title="字体颜色" name="1">
                    <div slot="value" :style="{
            backgroundColor:taColor,
            height:'100%',
            width:'40px'
          }"></div>
                    <div slot="right-icon"></div>
                    <pickerColor :isShow="showPickerColor" :bottom="bottomPickerColor" @callback='getPickerColor'
                                 :initColor="taColor"></pickerColor>
                </van-collapse-item>
                <van-collapse-item title="背景颜色" name="2">
                    <div slot="value" :style="{
            backgroundColor:taBgColor,
             height:'100%',
            width:'40px'
          }"></div>
                    <div slot="right-icon"></div>
                    <pickerColor :isShow="showPickerColor" :bottom="bottomPickerColor" @callback='getPickerColor'
                                 :initColor="taBgColor"></pickerColor>
                </van-collapse-item>
                <van-collapse-item title="滚动方向" name="3" v-if="text.txList[0].taMoveSpeed !== '0'">
                    <van-row>
                        <van-col span="8" :class="text.txList[0].taMove === '0'?'activate':''" @click="getNormal('0')">
                            自左向右
                        </van-col>
                        <van-col span="8" :class="text.txList[0].taMove === '1'?'activate':''" @click="getNormal('1')">
                            自右向左
                        </van-col>
                        <van-col span="8" :class="text.txList[0].taMove === '2'?'activate':''" @click="getNormal('2')">
                            自下向上
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="滚动速度" name="4">
                    <van-row>
                        <van-col span="6" :class="text.txList[0].taMoveSpeed === '0'?'activate':''"
                                 @click="getSpeed('0')">静止
                        </van-col>
                        <van-col span="6" :class="text.txList[0].taMoveSpeed === '1'?'activate':''"
                                 @click="getSpeed('1')">慢速
                        </van-col>
                        <van-col span="6" :class="text.txList[0].taMoveSpeed === '2'?'activate':''"
                                 @click="getSpeed('2')">中速
                        </van-col>
                        <van-col span="6" :class="text.txList[0].taMoveSpeed === '3'?'activate':''"
                                 @click="getSpeed('3')">快速
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="字体大小" name="5">
                    <div slot="right-icon"></div>
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center" slot="value">
                        <van-stepper v-model="text.txList[0].taFontSize" min="0" integer max="100"></van-stepper>
                    </div>
                </van-collapse-item>
                <van-collapse-item title="对齐方式" name="6" v-if="text.txList[0].taMoveSpeed === '0'">
                    <van-col span="8" :class="text.txList[0].taAlignment === item.id?'activate':''"
                             @click="getaligning(item.id)"
                             v-for="item in Alignment" :key="item.id">{{item.name}}
                    </van-col>
                </van-collapse-item>
            </van-collapse>
        </div>
        <div class="btn">
            <van-button type="danger" plain @click="close" size="small">取消</van-button>
            <span style="width: 20px;display: inline-block"></span>
            <van-button type="info" @click="submit" size="small">确定</van-button>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'vant'
    import {mapState} from 'vuex'
    import pickerColor from './helang-pickerColor.vue'

    export default {
        props: {
            text: {
                type: Object,
            },
        },
        data() {
            return {
                content: this.text.txList[0].taContent,
                type: this.text.coType,
                activeNames: ['1'],
                moveIndex: 0,
                speedIndex: 0,
                Alignment: [
                    {'id': '1', 'name': '左上角'},
                    {'id': '2', 'name': '顶部居中'},
                    {'id': '3', 'name': '右上角'},
                    {'id': '4', 'name': '左对齐居中'},
                    {'id': '5', 'name': '居中'},
                    {'id': '6', 'name': '右对齐居中'},
                    {'id': '7', 'name': '左下角'},
                    {'id': '8', 'name': '底部居中'},
                    {'id': '9', 'name': '右下角'}
                ],
                showPickerColor: false,
                bottomPickerColor: 0,
                taBgColor: '#00000000',
                taColor: "000000",
                fontColor: false,
                bjColor: false,
                placeholder: "请输入内容",
                title: "字幕"
            }
        },
        mounted() {
            if (this.text.coType === 'webPage') {
                this.placeholder = "请输入网址"
                this.title = "网页"
            } else if (this.text.coType === 'webPage') {
                this.placeholder = "请输入流媒体地址"
                this.title = "流媒体"
            } else {
                this.placeholder = "请输入内容"
                this.title = "字幕"
            }
            this.taColor = this.componentsList[this.controlIndex].txList[0].taColor
            this.taBgColor = this.componentsList[this.controlIndex].txList[0].taBgColor
        },
        methods: {
            submit() {
                if (this.content === '') {
                    Toast('请输入文字')
                    return
                }
                this.$emit('setText', this.content)
            },
            close() {
                this.$emit('close')
            },
            getNormal(index) {
                this.$store.state.componentsList[this.controlIndex].txList[0].taMove = index

                this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.$store.state.componentsList[this.controlIndex])
            },
            getSpeed(index) {
                this.$store.state.componentsList[this.controlIndex].txList[0].taMoveSpeed = index

                this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.$store.state.componentsList[this.controlIndex])
            },
            getaligning(index) {
                this.$store.state.componentsList[this.controlIndex].txList[0].taAlignment = index

                this.$set(this.$store.state.componentsList[this.controlIndex], this.controlIndex, this.$store.state.componentsList[this.controlIndex])
            },
            getPickerColor(color) {
                /* 隐藏弹窗 */
                this.showPickerColor = false
                this.activeNames = []
                /* 判断颜色值是否有效 */
                if (color) {
                    if (this.fontColor) {
                        this.taColor = color
                        this.$store.state.componentsList[this.controlIndex].txList[0].taColor = color
                    } else if (this.bjColor) {
                        this.taBgColor = color
                        this.$store.state.componentsList[this.controlIndex].txList[0].taBgColor = color
                    }
                    this.$set(this.componentsList, this.controlIndex, this.componentsList[
                        this.controlIndex])
                }
            },
            setactiveNames(id) {
                this.fontColor = false
                this.bjColor = false
                if (id === '1') {
                    this.fontColor = true
                    this.showPickerColor = true
                } else if (id === '2') {
                    this.bjColor = true
                    this.showPickerColor = true
                }
            }
        },
        computed: {
            ...mapState({
                controlIndex: state => state.controlIndex,
                componentsList: state => state.componentsList,
            }),
        },
        components: {
            pickerColor
        }
    }
</script>

<style lang="scss">
    @import "../../public/static/css/app";

    .addText {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        background: $uni-bg-color;
        box-sizing: border-box;
        z-index: 100;
        padding: 20px;

        .van-cell__value {
            flex: none;
        }

        .btn {
            text-align: right;
            margin-top: 30px;
        }

        .van-col {
            text-align: center;
        }

        .activate {
            background: #1B89FA;
            color: #fff;
        }

        .van-collapse-item__content {
            line-height: 40px !important;
            padding: 0;
            overflow: hidden;
        }

        .textarea {
            border: 1px solid #d8d8db;
            background: $uni-text-color-inverse;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 7px;
            width: 100%;
            height: 150px;
            margin-bottom: 20px;
        }
    }
</style>
